import axios from 'axios';
import { showGlobalNotification } from '../contexts/NotificationContext';

const intance = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

const triggerForceLogout = (displayMsg) => {
  if (!window.location.pathname.startsWith('/login') && !window.location.pathname.startsWith('/auth')) {
    window.localStorage.clear();
    if (displayMsg) {
      window.localStorage.setItem('logoutNotification', displayMsg);
    }
    window.location.href = '/login';
  }
};

intance.interceptors.request.use(
  (request) => {
    const accessToken = window.localStorage.getItem('accessToken');
    request.headers = {
      // "Authorization": `${token}`
      Authorization: `Bearer ${accessToken}`,
      WebAdmin: true,
      'Content-Type': request.headers['Content-Type'] || 'application/json'
    };
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

intance.interceptors.response.use(
  (response) => {
    if (response?.data?.success === false) {
      const serverMessage = response.data?.message || response.data?.error || '';
      const msgStr = serverMessage.toUpperCase();
      if (
        msgStr.includes('FORCE_LOGOUT') ||
        msgStr.includes('ACCOUNT_DEACTIVATED') ||
        msgStr === 'INACTIVE' ||
        msgStr === 'DEACTIVATED' ||
        (msgStr.includes('ACCOUNT') && (msgStr.includes('INACTIVE') || msgStr.includes('DEACTIVATED'))) ||
        (msgStr.includes('USER') && (msgStr.includes('INACTIVE') || msgStr.includes('DEACTIVATED')))
      ) {
        triggerForceLogout('Your account is inactive. Please contact your Admin.');
        return Promise.reject({
          message: serverMessage,
          status: response.status,
          data: response.data
        });
      }
      if (msgStr.includes('PERMISSIONS HAVE BEEN UPDATED') || msgStr.includes('SYNC YOUR NEW PERMISSIONS')) {
        triggerForceLogout(
          serverMessage || 'Your permissions have been updated by your administrator. Please log in again to sync your new permissions.'
        );
        return Promise.reject({
          message: serverMessage,
          status: response.status,
          data: response.data
        });
      }
    }
    if (response?.data?.success === true) {
      const respData = response.data.data;
      const subInfo = response.data.subscription;

      let hasSubscription = undefined;
      let subscriptionTier = undefined;

      if (subInfo && typeof subInfo === 'object' && subInfo.isSubscribe !== undefined) {
        hasSubscription = subInfo.isSubscribe;
        subscriptionTier = subInfo.tier;
      } else if (respData && respData.has_subscription !== undefined) {
        hasSubscription = respData.has_subscription;
        subscriptionTier = respData.plan?.code || respData.plan_code || respData.subscription;
      }

      if (hasSubscription !== undefined) {
        let isSuperAdmin = false;
        const userInfoStr = localStorage.getItem('userInfo');
        if (userInfoStr) {
          try {
            const userInfo = JSON.parse(userInfoStr);
            isSuperAdmin = userInfo.role_name === 'SuperAdmin';
            if (hasSubscription === false) {
              userInfo.subscription = isSuperAdmin ? true : false;
            } else {
              userInfo.subscription = subscriptionTier || true;
            }
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
          } catch (e) {
            console.error('Failed to update userInfo in interceptor', e);
          }
        }

        if (hasSubscription === false && !isSuperAdmin) {
          const currentPath = window.location.pathname;
          const isExcluded =
            currentPath.startsWith('/admin/subscription') ||
            currentPath.startsWith('/login') ||
            currentPath.startsWith('/logout') ||
            currentPath.startsWith('/auth');

          if (!isExcluded) {
            window.location.pathname = '/admin/subscription';
          }
        }
      }
    }
    return response;
  },
  (error) => {
    if (error.response) {
      const status = error.response.status;
      const serverMessage = error.response.data?.message || error.response.data?.error || '';
      const msgStr = serverMessage.toUpperCase();

      if (
        status === 401 ||
        status === 403 ||
        msgStr.includes('FORCE_LOGOUT') ||
        msgStr.includes('ACCOUNT_DEACTIVATED') ||
        msgStr.includes('ACCOUNT_DELETED') ||
        msgStr === 'INACTIVE' ||
        msgStr === 'DEACTIVATED' ||
        (msgStr.includes('ACCOUNT') && (msgStr.includes('INACTIVE') || msgStr.includes('DEACTIVATED'))) ||
        (msgStr.includes('USER') && (msgStr.includes('INACTIVE') || msgStr.includes('DEACTIVATED'))) ||
        msgStr.includes('PERMISSIONS HAVE BEEN UPDATED') ||
        msgStr.includes('SYNC YOUR NEW PERMISSIONS')
      ) {
        // Session expired or unauthorized or account inactive — clear credentials and redirect to login
        let displayMsg = 'Session expired. Please login again.';

        if (msgStr.includes('FORCE_LOGOUT')) {
          displayMsg = 'You have been logged out by Admin. Please login again.';
        } else if (
          msgStr.includes('ACCOUNT_DEACTIVATED') ||
          msgStr === 'INACTIVE' ||
          msgStr === 'DEACTIVATED' ||
          (msgStr.includes('ACCOUNT') && (msgStr.includes('INACTIVE') || msgStr.includes('DEACTIVATED'))) ||
          (msgStr.includes('USER') && (msgStr.includes('INACTIVE') || msgStr.includes('DEACTIVATED')))
        ) {
          displayMsg = 'Your account is inactive. Please contact your Admin.';
        } else if (msgStr.includes('ACCOUNT_DELETED')) {
          displayMsg = 'Your account has been deleted.';
        } else if (msgStr.includes('PASSWORD_CHANGED')) {
          displayMsg = 'Your password was changed. Please login again.';
        } else if (msgStr.includes('PERMISSIONS HAVE BEEN UPDATED') || msgStr.includes('SYNC YOUR NEW PERMISSIONS')) {
          displayMsg =
            serverMessage || 'Your permissions have been updated by your administrator. Please log in again to sync your new permissions.';
        }

        triggerForceLogout(displayMsg);
      } else {
        // Show user-friendly error message for all other errors
        const displayMessage = serverMessage || 'Something went wrong. Please try again.';
        console.error('API Error:', status, displayMessage);
        if (!error.config?.skipNotification) {
          showGlobalNotification(displayMessage, 'error');
        }
      }
    } else {
      // Network error or request was cancelled
      if (!error.config?.skipNotification) {
        showGlobalNotification('Something went wrong. Please try again.', 'error');
      }
    }

    return Promise.reject({
      message: error.response?.data?.message || error.message,
      status: error.response?.status,
      data: error.response?.data
    });
  }
);

export default intance;
